<template>
  <RequestsBase type="registration"/>
</template>

<script>
import RequestsBase from '@/pages/Requests/RequestsBase.vue';

export default {
  components: {
    RequestsBase,
  },
};
</script>
